const PilotRank = [
  'Pilot Officier',
  'Pilot Officier',
  'Pilot Officier',
  'Sgt Pilot',
  'Sgt Pilot',
  'Flying Officer',
  'Flying Officer',
  'Flying Lieutenant',
];
export default PilotRank;
